import { render, staticRenderFns } from "./BookService.vue?vue&type=template&id=2a868179"
import script from "./BookService.vue?vue&type=script&lang=js"
export * from "./BookService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports